import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { userPostForgot } from '../redux/actions';
import ReCAPTCHA from 'react-google-recaptcha';
class Forgot extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      submitted: false,
      statusMessage: "",
      captchaToken: "",
      captchaError: false,
      callback: {}
    }
    this.recaptchaRef = React.createRef();
  }
  handleCaptchaChange = token => {
    this.setState({ captchaToken: token, captchaError: false });
  };
  handleCaptchaExpired = () => {
    this.setState({ captchaToken: "", captchaError: true });
  };
  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value
    });
  }
  handleSubmit = event => {
    event.preventDefault()
    if (!this.state.captchaToken) {
      this.setState({ captchaError: true });
      return;
    }
    this.setState({ submitted: true })
    this.props.userPostForgot(this.state, this.callback)
  }
  callback = ( e, statusIsOk ) => {
    const statusMessage = statusIsOk ? "check_password_reset_link" : "server_error_desc";
    this.setState({ submitted: false, callback: e, statusMessage: statusMessage })
  }
  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <h1><FormattedMessage id="app.forgot_your_password" /></h1>
        <div className="input-wrap">
          <input
            id="forgot-email"
            type='email'
            name='email'
            placeholder='Email'
            value={this.state.email}
            onChange={this.handleChange.bind(this)}
            required
          />
          <label className="placeholder" htmlFor="forgot-email"><FormattedMessage id="app.email" /></label>
        </div>
        <div className="captcha-container">
          <ReCAPTCHA
            ref={this.recaptchaRef}
            sitekey={process.env.REACT_APP_RECAPTCHA || process.env.RECAPTCHA_SITE_KEY}
            theme="dark"
            onChange={this.handleCaptchaChange}
            onExpired={this.handleCaptchaExpired}
          />
          {this.state.captchaError && (<span className="captcha-label"><FormattedMessage id="please_verify_captcha" /></span>)}
        </div>
        <i className="errors_text">{!!this.state.statusMessage && (<FormattedMessage id={this.state.statusMessage} />)} {this.state.callback?.status} {this.state.callback?.errors?.email?.[0]} {this.state.callback?.errors?.email} {this.state.callback?.errors?.password?.[0]} {this.state.callback?.error} {this.state.callback?.message}</i>
        <div className="btn-wrap">
          <button type='submit' className={`btn ${this.state.submitted ? "submitted" : ""}`}><FormattedMessage id="app.enter" />
            <svg width="8.574358mm" height="9.8692408mm" viewBox="0 0 8.574358 9.8692408" version="1.1">
              <path d="M 5.5116534,2.38803 2.2173964,0.38070997 c -0.514732,-0.22305 -1.85303797,0.0172 -1.90451297,1.37683003 l -0.01288,6.31798 c -0.0025,1.22139 1.39419097,1.80501 2.17474297,1.31254 l 5.404666,-3.40994 c 0.380397,-0.24 0.627785,-1.58927 0.05564,-2.02354 L 7.5835704,3.6878" />
            </svg>
          </button>
        </div>
      </form>
    )
  }
}
const mapDispatchToProps = dispatch => ({
  userPostForgot: (userInfo, callback) => dispatch(userPostForgot(userInfo, callback))
})
export default connect(null, mapDispatchToProps)(Forgot);